import { createAction, createAsyncAction } from 'typesafe-actions';

import { LocalOrganisationMerge, Organisation } from './types';

export const LOAD_ORGANISATION = createAsyncAction(
  '@ORGANISATIONS/LOAD_ORGANISATION.REQUEST',
  '@ORGANISATIONS/LOAD_ORGANISATION.SUCCESS',
  '@ORGANISATIONS/LOAD_ORGANISATION.FAILURE',
)<string, string, string>();

export const UNLOAD_ORGANISATION = createAction(
  '@ORGANISATIONS/UNLOAD_ORGANISATION',
)<string>();

export const SET_LOADED_ORGANISATION = createAction(
  '@ORGANISATIONS/SET_LOADED_ORGANISATION',
)<Organisation>();

export const UNSET_LOADED_ORGANISATION = createAction(
  '@ORGANISATIONS/UNSET_LOADED_ORGANISATION',
)<string>();

export const doOrgLocalMergeData = createAction(
  '@ORGANISATIONS/doOrgLocalMergeData',
)<{ id: string; data: LocalOrganisationMerge }>();

export const doOrgLocalMergeRemoveKeys = createAction(
  '@ORGANISATIONS/doOrgLocalMergeRemoveKeys',
)<{ id: string; keys: string[] }>();
